export const IpModal = {
	Large: {
		width: '80vw',
	},
	Medium: {
		width: '80vw',
		maxWidth: 960,
	},
	Small: {
		width: '80vw',
		maxWidth: 480,
	},
};
